import React from 'react';

import { Alert as AntdAlert } from 'antd';

import { ConditionsReactivateFaqDto } from 'lib_api/lib/api/gen';

import './ConditionReactivateFaq.less';

interface ConditionReactivateFaqProps {
  conditions: ConditionsReactivateFaqDto | undefined;
}

function ConditionReactivateFaq({
  conditions,
}: ConditionReactivateFaqProps): React.ReactElement {
  return (
    <>
      {(conditions?.faqValid || conditions?.alreadyExists) && (
        <AntdAlert
          type="warning"
          className="alertInvalid"
          message={
            <>
              {conditions?.faqValid && (
                <p className="alertInvalid--txt">
                  La question est déjà valide.
                </p>
              )}
              {conditions?.alreadyExists && (
                <p className="alertInvalid--txt">
                  Une question active équivalente existe déjà dans le
                  référentiel.
                </p>
              )}
            </>
          }
        />
      )}
    </>
  );
}

export default ConditionReactivateFaq;
